/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UiRouteImport } from './routes/ui'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as AuthWWorkspaceSlugRouteRouteImport } from './routes/_auth/w.$workspaceSlug/route'
import { Route as PublicRsvpTokenRouteImport } from './routes/_public/rsvp.$token'
import { Route as AuthWWorkspaceSlugIndexRouteImport } from './routes/_auth/w.$workspaceSlug/index'
import { Route as AuthWWorkspaceSlugBudgetRouteImport } from './routes/_auth/w.$workspaceSlug/budget'
import { Route as AuthWWorkspaceSlugGuestsRouteImport } from './routes/_auth/w.$workspaceSlug/guests'
import { Route as AuthWWorkspaceSlugGuideRouteImport } from './routes/_auth/w.$workspaceSlug/guide'
import { Route as AuthWWorkspaceSlugRsvpRouteImport } from './routes/_auth/w.$workspaceSlug/rsvp'
import { Route as AuthWWorkspaceSlugScheduleRouteImport } from './routes/_auth/w.$workspaceSlug/schedule'
import { Route as AuthWWorkspaceSlugSettingsRouteImport } from './routes/_auth/w.$workspaceSlug/settings'
import { Route as AuthWWorkspaceSlugSuppliersRouteImport } from './routes/_auth/w.$workspaceSlug/suppliers'
import { Route as AuthWWorkspaceSlugTasksRouteImport } from './routes/_auth/w.$workspaceSlug/tasks'
import { Route as AuthWWorkspaceSlugSetupVendorSectionSlugRouteImport } from './routes/_auth/w.$workspaceSlug/setup.$vendorSectionSlug'
import { Route as AuthWWorkspaceSlugSetupBasicRouteImport } from './routes/_auth/w.$workspaceSlug/setup.basic'
import { Route as AuthWWorkspaceSlugSetupCeremonyRouteImport } from './routes/_auth/w.$workspaceSlug/setup.ceremony'
import { Route as AuthWWorkspaceSlugSetupFoodRouteImport } from './routes/_auth/w.$workspaceSlug/setup.food'
import { Route as AuthWWorkspaceSlugSetupGuestsRouteImport } from './routes/_auth/w.$workspaceSlug/setup.guests'
import { Route as AuthWWorkspaceSlugSetupLocationRouteImport } from './routes/_auth/w.$workspaceSlug/setup.location'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UiRoute = UiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRouteRoute,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWWorkspaceSlugRouteRoute = AuthWWorkspaceSlugRouteRouteImport.update({
  id: '/w/$workspaceSlug',
  path: '/w/$workspaceSlug',
  getParentRoute: () => AuthRouteRoute,
} as any)
const PublicRsvpTokenRoute = PublicRsvpTokenRouteImport.update({
  id: '/rsvp/$token',
  path: '/rsvp/$token',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AuthWWorkspaceSlugIndexRoute = AuthWWorkspaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
} as any)
const AuthWWorkspaceSlugBudgetRoute =
  AuthWWorkspaceSlugBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugGuestsRoute =
  AuthWWorkspaceSlugGuestsRouteImport.update({
    id: '/guests',
    path: '/guests',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugGuideRoute = AuthWWorkspaceSlugGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
} as any)
const AuthWWorkspaceSlugRsvpRoute = AuthWWorkspaceSlugRsvpRouteImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
} as any)
const AuthWWorkspaceSlugScheduleRoute =
  AuthWWorkspaceSlugScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSettingsRoute =
  AuthWWorkspaceSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSuppliersRoute =
  AuthWWorkspaceSlugSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugTasksRoute = AuthWWorkspaceSlugTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
} as any)
const AuthWWorkspaceSlugSetupVendorSectionSlugRoute =
  AuthWWorkspaceSlugSetupVendorSectionSlugRouteImport.update({
    id: '/setup/$vendorSectionSlug',
    path: '/setup/$vendorSectionSlug',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSetupBasicRoute =
  AuthWWorkspaceSlugSetupBasicRouteImport.update({
    id: '/setup/basic',
    path: '/setup/basic',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSetupCeremonyRoute =
  AuthWWorkspaceSlugSetupCeremonyRouteImport.update({
    id: '/setup/ceremony',
    path: '/setup/ceremony',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSetupFoodRoute =
  AuthWWorkspaceSlugSetupFoodRouteImport.update({
    id: '/setup/food',
    path: '/setup/food',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSetupGuestsRoute =
  AuthWWorkspaceSlugSetupGuestsRouteImport.update({
    id: '/setup/guests',
    path: '/setup/guests',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)
const AuthWWorkspaceSlugSetupLocationRoute =
  AuthWWorkspaceSlugSetupLocationRouteImport.update({
    id: '/setup/location',
    path: '/setup/location',
    getParentRoute: () => AuthWWorkspaceSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/ui': typeof UiRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/w/$workspaceSlug': typeof AuthWWorkspaceSlugRouteRouteWithChildren
  '/rsvp/$token': typeof PublicRsvpTokenRoute
  '/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/w/$workspaceSlug/guide': typeof AuthWWorkspaceSlugGuideRoute
  '/w/$workspaceSlug/rsvp': typeof AuthWWorkspaceSlugRsvpRoute
  '/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/w/$workspaceSlug/settings': typeof AuthWWorkspaceSlugSettingsRoute
  '/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersRoute
  '/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksRoute
  '/w/$workspaceSlug/': typeof AuthWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/setup/$vendorSectionSlug': typeof AuthWWorkspaceSlugSetupVendorSectionSlugRoute
  '/w/$workspaceSlug/setup/basic': typeof AuthWWorkspaceSlugSetupBasicRoute
  '/w/$workspaceSlug/setup/ceremony': typeof AuthWWorkspaceSlugSetupCeremonyRoute
  '/w/$workspaceSlug/setup/food': typeof AuthWWorkspaceSlugSetupFoodRoute
  '/w/$workspaceSlug/setup/guests': typeof AuthWWorkspaceSlugSetupGuestsRoute
  '/w/$workspaceSlug/setup/location': typeof AuthWWorkspaceSlugSetupLocationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/ui': typeof UiRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/rsvp/$token': typeof PublicRsvpTokenRoute
  '/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/w/$workspaceSlug/guide': typeof AuthWWorkspaceSlugGuideRoute
  '/w/$workspaceSlug/rsvp': typeof AuthWWorkspaceSlugRsvpRoute
  '/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/w/$workspaceSlug/settings': typeof AuthWWorkspaceSlugSettingsRoute
  '/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersRoute
  '/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksRoute
  '/w/$workspaceSlug': typeof AuthWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/setup/$vendorSectionSlug': typeof AuthWWorkspaceSlugSetupVendorSectionSlugRoute
  '/w/$workspaceSlug/setup/basic': typeof AuthWWorkspaceSlugSetupBasicRoute
  '/w/$workspaceSlug/setup/ceremony': typeof AuthWWorkspaceSlugSetupCeremonyRoute
  '/w/$workspaceSlug/setup/food': typeof AuthWWorkspaceSlugSetupFoodRoute
  '/w/$workspaceSlug/setup/guests': typeof AuthWWorkspaceSlugSetupGuestsRoute
  '/w/$workspaceSlug/setup/location': typeof AuthWWorkspaceSlugSetupLocationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/ui': typeof UiRoute
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/_auth/w/$workspaceSlug': typeof AuthWWorkspaceSlugRouteRouteWithChildren
  '/_public/rsvp/$token': typeof PublicRsvpTokenRoute
  '/_auth/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/_auth/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/_auth/w/$workspaceSlug/guide': typeof AuthWWorkspaceSlugGuideRoute
  '/_auth/w/$workspaceSlug/rsvp': typeof AuthWWorkspaceSlugRsvpRoute
  '/_auth/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/_auth/w/$workspaceSlug/settings': typeof AuthWWorkspaceSlugSettingsRoute
  '/_auth/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersRoute
  '/_auth/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksRoute
  '/_auth/w/$workspaceSlug/': typeof AuthWWorkspaceSlugIndexRoute
  '/_auth/w/$workspaceSlug/setup/$vendorSectionSlug': typeof AuthWWorkspaceSlugSetupVendorSectionSlugRoute
  '/_auth/w/$workspaceSlug/setup/basic': typeof AuthWWorkspaceSlugSetupBasicRoute
  '/_auth/w/$workspaceSlug/setup/ceremony': typeof AuthWWorkspaceSlugSetupCeremonyRoute
  '/_auth/w/$workspaceSlug/setup/food': typeof AuthWWorkspaceSlugSetupFoodRoute
  '/_auth/w/$workspaceSlug/setup/guests': typeof AuthWWorkspaceSlugSetupGuestsRoute
  '/_auth/w/$workspaceSlug/setup/location': typeof AuthWWorkspaceSlugSetupLocationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/ui'
    | '/onboarding'
    | '/invite/$invitationId'
    | '/w/$workspaceSlug'
    | '/rsvp/$token'
    | '/w/$workspaceSlug/budget'
    | '/w/$workspaceSlug/guests'
    | '/w/$workspaceSlug/guide'
    | '/w/$workspaceSlug/rsvp'
    | '/w/$workspaceSlug/schedule'
    | '/w/$workspaceSlug/settings'
    | '/w/$workspaceSlug/suppliers'
    | '/w/$workspaceSlug/tasks'
    | '/w/$workspaceSlug/'
    | '/w/$workspaceSlug/setup/$vendorSectionSlug'
    | '/w/$workspaceSlug/setup/basic'
    | '/w/$workspaceSlug/setup/ceremony'
    | '/w/$workspaceSlug/setup/food'
    | '/w/$workspaceSlug/setup/guests'
    | '/w/$workspaceSlug/setup/location'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/ui'
    | '/onboarding'
    | '/invite/$invitationId'
    | '/rsvp/$token'
    | '/w/$workspaceSlug/budget'
    | '/w/$workspaceSlug/guests'
    | '/w/$workspaceSlug/guide'
    | '/w/$workspaceSlug/rsvp'
    | '/w/$workspaceSlug/schedule'
    | '/w/$workspaceSlug/settings'
    | '/w/$workspaceSlug/suppliers'
    | '/w/$workspaceSlug/tasks'
    | '/w/$workspaceSlug'
    | '/w/$workspaceSlug/setup/$vendorSectionSlug'
    | '/w/$workspaceSlug/setup/basic'
    | '/w/$workspaceSlug/setup/ceremony'
    | '/w/$workspaceSlug/setup/food'
    | '/w/$workspaceSlug/setup/guests'
    | '/w/$workspaceSlug/setup/location'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/login'
    | '/signup'
    | '/ui'
    | '/_auth/onboarding'
    | '/invite/$invitationId'
    | '/_auth/w/$workspaceSlug'
    | '/_public/rsvp/$token'
    | '/_auth/w/$workspaceSlug/budget'
    | '/_auth/w/$workspaceSlug/guests'
    | '/_auth/w/$workspaceSlug/guide'
    | '/_auth/w/$workspaceSlug/rsvp'
    | '/_auth/w/$workspaceSlug/schedule'
    | '/_auth/w/$workspaceSlug/settings'
    | '/_auth/w/$workspaceSlug/suppliers'
    | '/_auth/w/$workspaceSlug/tasks'
    | '/_auth/w/$workspaceSlug/'
    | '/_auth/w/$workspaceSlug/setup/$vendorSectionSlug'
    | '/_auth/w/$workspaceSlug/setup/basic'
    | '/_auth/w/$workspaceSlug/setup/ceremony'
    | '/_auth/w/$workspaceSlug/setup/food'
    | '/_auth/w/$workspaceSlug/setup/guests'
    | '/_auth/w/$workspaceSlug/setup/location'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  UiRoute: typeof UiRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui': {
      id: '/ui'
      path: '/ui'
      fullPath: '/ui'
      preLoaderRoute: typeof UiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/w/$workspaceSlug': {
      id: '/_auth/w/$workspaceSlug'
      path: '/w/$workspaceSlug'
      fullPath: '/w/$workspaceSlug'
      preLoaderRoute: typeof AuthWWorkspaceSlugRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_public/rsvp/$token': {
      id: '/_public/rsvp/$token'
      path: '/rsvp/$token'
      fullPath: '/rsvp/$token'
      preLoaderRoute: typeof PublicRsvpTokenRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_auth/w/$workspaceSlug/': {
      id: '/_auth/w/$workspaceSlug/'
      path: '/'
      fullPath: '/w/$workspaceSlug/'
      preLoaderRoute: typeof AuthWWorkspaceSlugIndexRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/budget': {
      id: '/_auth/w/$workspaceSlug/budget'
      path: '/budget'
      fullPath: '/w/$workspaceSlug/budget'
      preLoaderRoute: typeof AuthWWorkspaceSlugBudgetRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/guests': {
      id: '/_auth/w/$workspaceSlug/guests'
      path: '/guests'
      fullPath: '/w/$workspaceSlug/guests'
      preLoaderRoute: typeof AuthWWorkspaceSlugGuestsRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/guide': {
      id: '/_auth/w/$workspaceSlug/guide'
      path: '/guide'
      fullPath: '/w/$workspaceSlug/guide'
      preLoaderRoute: typeof AuthWWorkspaceSlugGuideRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/rsvp': {
      id: '/_auth/w/$workspaceSlug/rsvp'
      path: '/rsvp'
      fullPath: '/w/$workspaceSlug/rsvp'
      preLoaderRoute: typeof AuthWWorkspaceSlugRsvpRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/schedule': {
      id: '/_auth/w/$workspaceSlug/schedule'
      path: '/schedule'
      fullPath: '/w/$workspaceSlug/schedule'
      preLoaderRoute: typeof AuthWWorkspaceSlugScheduleRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/settings': {
      id: '/_auth/w/$workspaceSlug/settings'
      path: '/settings'
      fullPath: '/w/$workspaceSlug/settings'
      preLoaderRoute: typeof AuthWWorkspaceSlugSettingsRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/suppliers': {
      id: '/_auth/w/$workspaceSlug/suppliers'
      path: '/suppliers'
      fullPath: '/w/$workspaceSlug/suppliers'
      preLoaderRoute: typeof AuthWWorkspaceSlugSuppliersRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/tasks': {
      id: '/_auth/w/$workspaceSlug/tasks'
      path: '/tasks'
      fullPath: '/w/$workspaceSlug/tasks'
      preLoaderRoute: typeof AuthWWorkspaceSlugTasksRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/$vendorSectionSlug': {
      id: '/_auth/w/$workspaceSlug/setup/$vendorSectionSlug'
      path: '/setup/$vendorSectionSlug'
      fullPath: '/w/$workspaceSlug/setup/$vendorSectionSlug'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupVendorSectionSlugRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/basic': {
      id: '/_auth/w/$workspaceSlug/setup/basic'
      path: '/setup/basic'
      fullPath: '/w/$workspaceSlug/setup/basic'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupBasicRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/ceremony': {
      id: '/_auth/w/$workspaceSlug/setup/ceremony'
      path: '/setup/ceremony'
      fullPath: '/w/$workspaceSlug/setup/ceremony'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupCeremonyRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/food': {
      id: '/_auth/w/$workspaceSlug/setup/food'
      path: '/setup/food'
      fullPath: '/w/$workspaceSlug/setup/food'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupFoodRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/guests': {
      id: '/_auth/w/$workspaceSlug/setup/guests'
      path: '/setup/guests'
      fullPath: '/w/$workspaceSlug/setup/guests'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupGuestsRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
    '/_auth/w/$workspaceSlug/setup/location': {
      id: '/_auth/w/$workspaceSlug/setup/location'
      path: '/setup/location'
      fullPath: '/w/$workspaceSlug/setup/location'
      preLoaderRoute: typeof AuthWWorkspaceSlugSetupLocationRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRouteRoute
    }
  }
}

interface AuthWWorkspaceSlugRouteRouteChildren {
  AuthWWorkspaceSlugBudgetRoute: typeof AuthWWorkspaceSlugBudgetRoute
  AuthWWorkspaceSlugGuestsRoute: typeof AuthWWorkspaceSlugGuestsRoute
  AuthWWorkspaceSlugGuideRoute: typeof AuthWWorkspaceSlugGuideRoute
  AuthWWorkspaceSlugRsvpRoute: typeof AuthWWorkspaceSlugRsvpRoute
  AuthWWorkspaceSlugScheduleRoute: typeof AuthWWorkspaceSlugScheduleRoute
  AuthWWorkspaceSlugSettingsRoute: typeof AuthWWorkspaceSlugSettingsRoute
  AuthWWorkspaceSlugSuppliersRoute: typeof AuthWWorkspaceSlugSuppliersRoute
  AuthWWorkspaceSlugTasksRoute: typeof AuthWWorkspaceSlugTasksRoute
  AuthWWorkspaceSlugIndexRoute: typeof AuthWWorkspaceSlugIndexRoute
  AuthWWorkspaceSlugSetupVendorSectionSlugRoute: typeof AuthWWorkspaceSlugSetupVendorSectionSlugRoute
  AuthWWorkspaceSlugSetupBasicRoute: typeof AuthWWorkspaceSlugSetupBasicRoute
  AuthWWorkspaceSlugSetupCeremonyRoute: typeof AuthWWorkspaceSlugSetupCeremonyRoute
  AuthWWorkspaceSlugSetupFoodRoute: typeof AuthWWorkspaceSlugSetupFoodRoute
  AuthWWorkspaceSlugSetupGuestsRoute: typeof AuthWWorkspaceSlugSetupGuestsRoute
  AuthWWorkspaceSlugSetupLocationRoute: typeof AuthWWorkspaceSlugSetupLocationRoute
}

const AuthWWorkspaceSlugRouteRouteChildren: AuthWWorkspaceSlugRouteRouteChildren =
  {
    AuthWWorkspaceSlugBudgetRoute: AuthWWorkspaceSlugBudgetRoute,
    AuthWWorkspaceSlugGuestsRoute: AuthWWorkspaceSlugGuestsRoute,
    AuthWWorkspaceSlugGuideRoute: AuthWWorkspaceSlugGuideRoute,
    AuthWWorkspaceSlugRsvpRoute: AuthWWorkspaceSlugRsvpRoute,
    AuthWWorkspaceSlugScheduleRoute: AuthWWorkspaceSlugScheduleRoute,
    AuthWWorkspaceSlugSettingsRoute: AuthWWorkspaceSlugSettingsRoute,
    AuthWWorkspaceSlugSuppliersRoute: AuthWWorkspaceSlugSuppliersRoute,
    AuthWWorkspaceSlugTasksRoute: AuthWWorkspaceSlugTasksRoute,
    AuthWWorkspaceSlugIndexRoute: AuthWWorkspaceSlugIndexRoute,
    AuthWWorkspaceSlugSetupVendorSectionSlugRoute:
      AuthWWorkspaceSlugSetupVendorSectionSlugRoute,
    AuthWWorkspaceSlugSetupBasicRoute: AuthWWorkspaceSlugSetupBasicRoute,
    AuthWWorkspaceSlugSetupCeremonyRoute: AuthWWorkspaceSlugSetupCeremonyRoute,
    AuthWWorkspaceSlugSetupFoodRoute: AuthWWorkspaceSlugSetupFoodRoute,
    AuthWWorkspaceSlugSetupGuestsRoute: AuthWWorkspaceSlugSetupGuestsRoute,
    AuthWWorkspaceSlugSetupLocationRoute: AuthWWorkspaceSlugSetupLocationRoute,
  }

const AuthWWorkspaceSlugRouteRouteWithChildren =
  AuthWWorkspaceSlugRouteRoute._addFileChildren(
    AuthWWorkspaceSlugRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthWWorkspaceSlugRouteRoute: typeof AuthWWorkspaceSlugRouteRouteWithChildren
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthWWorkspaceSlugRouteRoute: AuthWWorkspaceSlugRouteRouteWithChildren,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicRsvpTokenRoute: typeof PublicRsvpTokenRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicRsvpTokenRoute: PublicRsvpTokenRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  UiRoute: UiRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
